import { Component, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { LoggerService } from '../../shared/util/logger';
import { TeamMemberService } from '../../team/team-member/team-member.service';
import { TeamForBackoffice, TeamMemberForBackoffice, TransformedBounce } from './bounce.type';
import { BouncesService, generateMailTo } from "./bounces.service";

@Component({
    selector: 'bounces',
    templateUrl: './bounces.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class BouncesComponent implements OnInit {
    
    bouncesData: TransformedBounce[];
    loading: boolean;
    constructor(
        private logger : LoggerService, 
        private bouncesService: BouncesService, 
        private teamMemberService: TeamMemberService
    ) {}

    ngOnInit() {
        this.loadData();
        this.logger.info("bounces loaded");
    }

    async loadData(){
        this.loading = true;
        this.bouncesData = await this.bouncesService.query();
        this.loading = false;
    }

    async remove(teamMemberId: string){
        await this.bouncesService.removeBounce(teamMemberId);
        await this.loadData();
    }

    activeInTeamChanged(bounce: TransformedBounce, team: TeamForBackoffice) { 
        this.teamMemberService.toggle(team.id, bounce.teamMember.id).then(() => {
            if (bounce.teamMember.teams.length === 1) {
                this.remove(bounce.teamMember.id);
            } else {
                this.loadData();
            }
        });
    }

    generateMailTo (teamMember: TeamMemberForBackoffice){
        return generateMailTo(teamMember);
    }

    async deleteAll(bouncesData: TransformedBounce[]){
       try {
            await Promise.all(bouncesData.map( async (bounce) => {
                await this.bouncesService.removeBounce(bounce.teamMember.id);
            }))
            this.loadData();
        } catch (error) {
            this.logger.error(error.data);
        }

    }

}